import { gsap } from "gsap";
import { Container, Graphics, Sprite, Texture } from "pixi.js";

import { AbstractBitmapText } from "../../../../abstracts/graphics/AbstractBitmapText";
import { AbstractView } from "../../../../abstracts/modules/AbstractView";
import { AbstractWinScreen } from "../../../../abstracts/modules/screens/AbstractWinScreen";
import { generateScaledSprite } from "../../../../abstracts/utils/GraphicUtils";
import { displayConfig } from "../../../UCConfig";
import { UCFontsNames } from "../../../assetsLoader/UCAssetsNames";

export class UCHawgSpinsScreen extends AbstractWinScreen {
    protected hawkSpinsContainer: Container;
    protected fsLeftText: AbstractBitmapText;

    constructor(parentContainer: AbstractView) {
        super(`UCHawkSpinsScreen`, parentContainer);
    }

    protected init(): void {
        super.init();

        this.hawkSpinsContainer = new Container();

        this.bgGraphics = new Graphics();
        this.bgGraphics.beginFill(0x000000);
        this.bgGraphics.drawRect(
            0,
            0,
            displayConfig.backgroundWidth,
            displayConfig.backgroundHeight
        );
        this.bgGraphics.endFill();
        this.bgGraphics.alpha = 0.7;
        this.bgGraphics.name = `hawkBgGraphics`;
        this.bgGraphics.pivot.set(this.bgGraphics.width / 2, this.bgGraphics.height / 2);

        this.addChild(this.bgGraphics);

        const hawgImageSprite = new Sprite(Texture.from(`FS_INTRO`));
        hawgImageSprite.name = `hawkImage`;
        hawgImageSprite.anchor.set(0.5);
        hawgImageSprite.y = -12;
        this.hawkSpinsContainer.addChild(hawgImageSprite);

        const spinsNameSprite = generateScaledSprite(`hawgSpins`);
        spinsNameSprite.name = `hawkSpins`;
        spinsNameSprite.anchor.set(0.5);
        spinsNameSprite.y = -208;
        this.hawkSpinsContainer.addChild(spinsNameSprite);

        const spinsTextSprite = generateScaledSprite(`spinsText`);
        spinsTextSprite.name = `spinsText`;
        spinsTextSprite.anchor.set(0.5);
        spinsTextSprite.y = -140;
        this.hawkSpinsContainer.addChild(spinsTextSprite);

        this.addChild(this.hawkSpinsContainer);

        this.fsLeftText = new AbstractBitmapText(``, {
            fontName: UCFontsNames.UC_WAYS,
            fontSize: 12,
        });
        this.fsLeftText.y = -280;

        this.hawkSpinsContainer.addChild(this.fsLeftText);
        // spinsNameSprite.position.set(840, 670);
    }

    public override getGsapAnimation(spinsWon: number = 0): gsap.core.Tween | gsap.core.Timeline {
        const tl = gsap.timeline({
            onStart: () => {
                this.selfAddToParent();
            },
            onComplete: () => {
                this.selfRemoveFromParent();
            },
        });

        const duration = 1.3;
        const showBg = gsap.fromTo(
            this.bgGraphics,
            { alpha: 0 },
            {
                alpha: 0.6,
                duration: duration * 0.4,
            }
        );
        tl.add(showBg, 0);

        const showHawgContainerTween = gsap.fromTo(
            this.hawkSpinsContainer,
            { alpha: 0, pixi: { scale: 0.8 } },
            {
                alpha: 1,
                pixi: { scale: 1 },
                duration: duration * 0.5,
                ease: `back.out(1.7)`,
                onStart: () => {
                    this.selfAddToParent();
                    this.fsLeftText.updateValue(`${spinsWon}`);
                },
            }
        );
        tl.add(showHawgContainerTween, 0);

        const hideHawgContainerTween = gsap.fromTo(
            this.hawkSpinsContainer,
            { alpha: 1, pixi: { scale: 1 } },
            {
                alpha: 0,
                pixi: { scale: 1.1 },
                duration: 0.2 * duration,
                ease: `back.in(1.4)`,
            }
        );
        tl.add(hideHawgContainerTween, 0.8 * duration);

        const hideBg = gsap.fromTo(
            this.bgGraphics,
            { alpha: 0.6 },
            {
                alpha: 0,
                duration: 0.2 * duration,
                ease: `back.in(1.4)`,
            }
        );
        tl.add(hideBg, `<`);

        return tl;
    }
}
